import { CSSProperties } from 'react';
import { IconType } from '.';

interface TriangleRightProps extends IconType {
  style?: CSSProperties;
}

export default function TriangleRight({ className = '', color = '#fff', height = 8.583, style, width = 5.15 }: TriangleRightProps) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 5.15 8.583">
      <path
        id="caret-left-solid"
        d="M.276,100.82a.859.859,0,0,1,0-1.215l3.432-3.432a.86.86,0,0,1,1.467.609v6.863a.86.86,0,0,1-1.467.609L.276,100.823Z"
        transform="translate(5.175 104.505) rotate(180)"
        fill="#fff"
      />
    </svg>
  );
}
